// `leadSources`: Swift `LeadSource` (GroundTeam/Models/Record.swift), what `Record.sourceId` points at. Decoding
// template `LeadSource(name: "")` (GroundTeam/Sync/ResilientDecoding.swift:107).

import type { JsonObject } from '../wire';
import { newId } from '../uuid';
import {
  STRING,
  UUID,
  createModel,
  decodeModel,
  field,
  type Decoded,
  type FieldMap,
  type Known,
  type Passthrough,
} from './fields';

export interface LeadSourcePayload extends Passthrough {
  id: string;
  name: string;
}

export const LEAD_SOURCE_KEYS = ['id', 'name'] as const satisfies readonly (keyof Known<LeadSourcePayload>)[];

export const LEAD_SOURCE_FIELDS: FieldMap<LeadSourcePayload> = {
  id: field.strict(UUID),
  name: field.req(STRING, () => ''),
};

export function decodeLeadSource(raw: JsonObject, envelopeId?: string): Decoded<LeadSourcePayload> {
  return decodeModel(LEAD_SOURCE_FIELDS, raw, {}, envelopeId);
}

export type LeadSourceInit = Partial<Known<LeadSourcePayload>> & { name: string };

export function newLeadSource(init: LeadSourceInit): LeadSourcePayload {
  return createModel(LEAD_SOURCE_FIELDS, { id: newId() }, init, 'leadSources');
}
